
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-delivery",
      function () {
        return require("private-next-pages/order-delivery/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order-delivery"])
      });
    }
  